import styled from 'styled-components';
import { ThemeConstants } from '../../../../../config/theme/appTheme/appTheme';

export const StyledFulfillmentStatusPill = styled.span`
  .status-pill {
    padding: calc(${ThemeConstants.SPACING.XXS} + 1px) ${ThemeConstants.SPACING.SM}
      calc(${ThemeConstants.SPACING.XXS} - 1px);
  }
`;
